import { render, staticRenderFns } from "./AddCompanyComponent.vue?vue&type=template&id=6d2deb9e&"
import script from "./AddCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./AddCompanyComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports